
























import { HtmlModal, Scrollbar, Terms } from '@/app/components';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
    name: 'TermsModal',
    components: { HtmlModal, Scrollbar, Terms },
});
